import React from "react";
import amplitude from "amplitude-js";
import { AmplitudeProvider } from "react-amplitude-hooks";
import { isMobile } from "react-device-detect";
import { ThemeProvider } from "emotion-theming";
import * as themes from "style/theme";
import { ThemesTypes } from "components/Travel/interface";
import Routes from "components/App/presenter";

const themeGroup: ThemesTypes = themes;
const AMPLITUDE_KEY = process.env.REACT_APP_AMPLITUDE_KEY || "";

const App: React.FC = () => {
  let switchTheme;
  let company: string = "mrt";

  if (isMobile) {
    switchTheme = themeGroup[company];
  } else {
    company = company + "PC";
    switchTheme = themeGroup[company];
  }

  return (
    <AmplitudeProvider
      amplitudeInstance={amplitude.getInstance()}
      apiKey={AMPLITUDE_KEY}
    >
      <ThemeProvider theme={switchTheme}>
        <Routes />
      </ThemeProvider>
    </AmplitudeProvider>
  );
};

export default App;
